import { ToastNotificationType } from "./enums";

export class ToastNotification {
    id: string;
    message: string;
    type: ToastNotificationType;
    duration?: number;
    isSlidingInFromRight: boolean;
    isFadingOut: boolean;

    constructor(value?: Partial<ToastNotification>) {
        if (value) {
            Object.assign(this, value);
        }
    }
}